import StatusBox from "../../../../../../common/components/atom/StatusBox/StatusBox";
import Table, {
  TableRow,
} from "../../../../../../common/components/molecule/Table/Table";
import { themeColorAppJs } from "../../../../../../styles/theme/themeColor";
import { StationStatus } from "../../../../types/stations.types";

export interface StationItem {
  id: string;
  name: string;
  city: string;
  country: string;
  hardwareId: string;
  OrganizationNameRender: () => JSX.Element;
  onClick?: () => void;
  status?: StationStatus;
  nbChargePointRender: () => JSX.Element;
  HardwareNameRender: () => JSX.Element;

}

export interface StattionListViewProps {
  content?: StationItem[];
  nbFound?: number;
}

export default function StattionListView({ content, nbFound }: StattionListViewProps) {
  const contentFormated: TableRow[] =
    content?.map((station) => ({
      id: station.id,
      onRowClick: station.onClick,
      data: [
        station.name,
        station.city,
        station.country,
        station.HardwareNameRender,
        () => station.nbChargePointRender && station.nbChargePointRender(),
        () => station.OrganizationNameRender(),
      //  () =>  statusConverterStation(station.status),

      ],
    })) || [];

  return (
    <div>
      <Table
        headerTitle={[
          "Nom",
          "Ville",
          "Pays",
          "Device ID",
          "Nb points de charge",
          "Organisation",
          //"Statut",
        ]}
        bodyData={contentFormated}
        emptyMessage="Aucune station trouvée"
        NbFoundViewProps={{
          nbFound: nbFound,
          itemName: { single: "station trouvée", plurial: "stations trouvées" },
        }}
      />
    </div>
  );
}

export const statusConverterStation = (status: StationStatus | undefined) => {
  const size = { width: "80px", height: "20px", font: "0.8rem" };
  switch (status) {
    case "AVAILABLE":
      return (
        <StatusBox
          size={size}
          color={{
            text: themeColorAppJs.green.dark,
            background: themeColorAppJs.green.light,
          }}
        >
          Disponible
        </StatusBox>
      );

    case "ACTIVATED":
      return (
        <StatusBox
          size={size}
          color={{
            text: themeColorAppJs.blue.dark,
            background: themeColorAppJs.blue.light,
          }}
        >
          Activée
        </StatusBox>
      );
    case "DISABLED":
      return (
        <StatusBox
          size={size}
          color={{
            text: themeColorAppJs.red.dark,
            background: themeColorAppJs.red.light,
          }}
        >
          Désactivée
        </StatusBox>
      );
    case "MAINTENANCE":
      return (
        <StatusBox
          size={size}
          color={{
            text: themeColorAppJs.orange.dark,
            background: themeColorAppJs.orange.light,
          }}
        >
          En maintenance
        </StatusBox>
      );
    default:
      return (
        <StatusBox
          size={size}
          color={{
            text: themeColorAppJs.gray.dark,
            background: themeColorAppJs.gray.light,
          }}
        >
          {status}
        </StatusBox>
      );
  }
};
